'use client';
import { useState } from 'react';
import { Button } from 'components/ui/button';
import { ApplyFormDialog } from 'app/(authenticated)/(member)/discovery/_components/ApplyFormDialog';
import React from 'react';
import { CommunityQuery } from 'generated/operations';

type OwnerJoinOnboardingProps = {
  community: Extract<CommunityQuery['community'], any>;
}

export default function OwnerJoinOnboarding(props: OwnerJoinOnboardingProps) {
  const [applyOpen, setApplyOpen] = useState(false);

  return (
    <>
      <div className={'flex flex-col gap-4 rounded-2xl p-6 bg-brand-500 text-white'}>
        <h3 className={'text-x-large font-bold'}>🚀 Your Application`s Ready</h3>
        <p className={'text-medium'}>Pre-filled for your space. Finish it to unlock your public profile.</p>
        <Button variant={'secondaryBrand'} onClick={() => setApplyOpen(true)}>Fill Application</Button>
      </div>
      {applyOpen && (
        <ApplyFormDialog
          community={props.community}
          open={applyOpen}
          onOpenChange={setApplyOpen}
        />
      )}
    </>
  );
}
